<template>
  <div class="c-resource-list-sign-up">
    <div v-if="fields && fields.image" class="c-resource-list-sign-up__icon">
      <sc-image v-if="fields && fields.image" :media="fields.image" />
    </div>
    <sc-text
      tag="div"
      v-if="fields && fields.title"
      :field="fields.title"
      class="c-resource-list-sign-up__title"
    />
    <div class="c-resource-list-sign-up__cta">
      <sc-link
        v-if="fields && fields.cta && fields.cta.value.text"
        :field="fields.cta"
        class="c-cta--primary"
        :class="fields.cta.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, Link, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-List-Sign-Up',
  components: {
    ScText: Text,
    ScLink: Link,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-resource-list-sign-up {
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 2.4rem;
  border-radius: 4px;
  background: linear-gradient(
    180deg,
    var(--Dark-Blue, #003b5c) -3.05%,
    var(--Light-Blue, #0086bf) 100%
  );
  margin-bottom: 6.2rem;

  @include tablet-up {
    flex-wrap: nowrap;
    align-items: center;
  }

  &__icon {
    width: 6rem;
    margin-right: 1.6rem;

    img {
      max-width: 6rem;
      height: auto;
      max-height: 6rem;
    }
  }

  &__title {
    flex: 1;
    @include font-styles('Arial', 1.8rem, 200, normal, 2.4rem, 0, $white);
    margin-right: 4rem;
    margin-bottom: 1.5rem;

    @include tablet-up {
      font-size: 2rem;
      line-height: 2.8rem;
      margin-bottom: 0;
    }

    @include desktop-up {
      font-size: 2.4rem;
      line-height: 3rem;
    }
  }

  &__cta {
    @media (max-width: 767px) {
      flex: 1 1 100%;
    }

    .c-cta--primary {
      margin-bottom: 0;
      font-weight: 400;
    }
  }
}
</style>
